import type { SVGProps } from 'react'

const Inbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17.5 11.667h-4.167l-1.666 2.5h-3.334l-1.666-2.5H2.5" />
    <path d="M5.378 4.5a1.667 1.667 0 0 0-1.49.92L2.5 8.333v5a1.667 1.667 0 0 0 1.667 1.667h11.666a1.667 1.667 0 0 0 1.667-1.667v-5L16.112 5.42a1.667 1.667 0 0 0-1.49-.92H5.378Z" />
  </svg>
)

export default Inbox
